import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import { pick } from "lodash";
import type {
  APIResponse,
  MatterLien,
  SourceOwnedConnectionCreate,
} from "@/lib/types";

type CreateMatterLienInput = Pick<MatterLien, "matterId"> &
  Partial<Omit<MatterLien, "connections" | "matterId">> & {
    connections?: SourceOwnedConnectionCreate[];
    trustChecks?: unknown;
  };

type UpdateMatterLienInput = Pick<MatterLien, "id" | "matterId"> &
  Partial<Omit<MatterLien, "connections" | "id" | "matterId">> & {
    trustChecks?: unknown;
  };

export const createMatterLien = (input: CreateMatterLienInput) => {
  const payload = { ...input };
  delete payload.trustChecks;

  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MatterLien>>("matters/v4/liens", payload)
    .then((res) => res.data);
};

export const updateMatterLien = (input: UpdateMatterLienInput) => {
  const payload = pick(input, [
    "id",
    "matterId",
    "dateModified",
    "category",
    "description",
    "goalAmount",
    "label",
    "negotiatedAmount",
    "originalAmount",
    "paidAmount",
    "reductionFeeAgreement",
    "status",
    "subCategory",
    "type",
  ]);

  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<MatterLien>>(`${baseFastApiMatterRoute}/liens`, payload)
    .then((res) => res.data);
};

export const deleteMatterLien = (data: Pick<MatterLien, "id" | "matterId">) =>
  authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterLien>
    >(`${baseFastApiMatterRoute}/liens/${data.id}`)
    .then((res) => res.data);
